<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@font-face {
  font-family: Emoji;
  src: local("Apple Color Emoji"), local("Segoe Ui Emoji"),
    local("Segoe UI Symbol"), local("Noto Color Emoji");
  unicode-range: U+1F000-1F644, u+203C-3299;
}
html {
  font-family: system-ui, -apple-system, Segoe UI, Rototo, Emoji, Helvetica,
    Arial, sans-serif;
}
#app {
  width: 100%;
  height: 100%;
}
i {
  cursor: pointer;
}
.fz24 {
  font-size: 24px;
}
.ml {
  margin-left: 9px;
}

.data-header {
  .el-card__body {
    padding: 15px !important;
  }
}
#order-chat {
  .el-card__body {
    padding: 10px !important;
  }
}

#nurse-chat {
  .el-card__body {
    padding: 10px !important;
  }
}
</style>
